export class SSEParser {
    private buffer: string = '';

    constructor() {
        this.buffer = '';
    }

    process(chunk: string): string[] {
        this.buffer += chunk;

        const messages: string[] = [];
        let lineStart = 0;

        for (let i = 0; i < this.buffer.length; i++) {
            if (this.buffer[i] === '\n') {
                const line = this.buffer.slice(lineStart, i);
                if (line.startsWith('data: ')) {
                    const data = line.slice(6);
                    if (data !== '[DONE]') {
                        messages.push(data);
                    }
                }
                lineStart = i + 1;
            }
        }

        if (lineStart < this.buffer.length) {
            this.buffer = this.buffer.slice(lineStart);
        } else {
            this.buffer = '';
        }

        return messages;
    }

    reset(): void {
        this.buffer = '';
    }
}

export async function* streamSSE(reader: ReadableStreamDefaultReader): AsyncGenerator<string> {
    const parser = new SSEParser();
    const decoder = new TextDecoder();

    while (true) {
        const { done, value } = await reader.read();
        if (done) break;

        const chunk = decoder.decode(value);
        const messages = parser.process(chunk);

        for (const message of messages) {
            yield message;
        }
    }
}